
import { defineComponent } from '@nuxtjs/composition-api'
import ElementSnapSlider from '~/components/element/elementSnapSlider.vue'
import ElementHeadline from '~/components/element/elementHeadline.vue'

export default defineComponent({
  components: {
    ElementHeadline,
    ElementSnapSlider,
  },
  setup() {
    return {}
  },
})
